<template>
  <section>
    <div class="mx-4 sm:mx-2">
      <h2>Choose up to {{this.slots}} flavours</h2>
      <div class="flavours sm:flex">
        <standard-button 
          v-for="item in filteredFlavours" :key="item.id"
          @click="setFlavour(item.id)"
          :active="value.includes(item.id)"
          :disabled="disabled && !value.includes(item.id)"
        >
          {{item.name}}
        </standard-button>
      </div>
    </div>
  </section>
</template>


<script>
import StandardButton from './FlavourButton'
import { filter, find } from 'lodash'
export default {
  model: {
    value: 'value',
    event: 'input'
  },
  props: {
    value: {},
    group: {},
    sku: {}
  },
  components: {
    StandardButton
  },
  methods: {
    setFlavour(id) {
      if(this.value.includes(id)) {
        this.$emit('input', filter(this.value, o => o != id))
      } else {
        if(!this.disabled) {
          this.$emit('input', this.value.concat(id))
        }
      }
    }
  },
  computed: {
    product() {
      return find(this.$root.$data.products, {sku: this.sku})
    },
    slots() {
      return Math.min(6,this.product.slots)
    },
    filteredFlavours() {
      return filter(this.$root.$data.flavours, {cupcakes: "YES"})
    },
    disabled() {
      return this.value.length >= this.slots
    }
  }
}
</script>
